import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <span
              className={`w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
              }`}
            >
              <i className="ri-shield-keyhole-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span
                className={`font-heading font-bold text-lg tracking-wide transition-colors ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                {siteInfo.name}
              </span>
              <span
                className={`text-[11px] tracking-[0.2em] hidden sm:block transition-colors ${
                  solid ? "text-foreground-500" : "text-background-200"
                }`}
              >
                ANONYMOUS CHANNEL
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? solid
                        ? "text-primary-700 bg-primary-100"
                        : "text-background-50 bg-background-50/15"
                      : solid
                        ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                        : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/submit"
              className={`hidden sm:inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                solid
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-background-50 text-foreground-950 hover:bg-accent-300"
              }`}
            >
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              立即匿名投稿
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
                solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
              }`}
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-4 flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/submit"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              立即匿名投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}